module.exports = __webpack_public_path__ + "img/cafe_international.d76ef06b.jpg";